import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { PlanSuggestionInfo } from '../../types/generated/Account.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetShareFeatureGateSuggestionsQueryVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
}>;


export type GetShareFeatureGateSuggestionsQuery = { __typename?: 'Query', share?: { __typename?: 'AdHocAssetsShare', id: string, suggestedPlan?: Array<{ __typename?: 'PlanSuggestion', feature: string, includedInCurrentPlan: boolean, plan?: { __typename?: 'Plan', cost: number, id: string, name?: string | null, period: Types.PlanPeriod, tier: Types.PlanTier, title: string, userLimit?: number | null, version?: number | null } | null } | null> | null } | { __typename?: 'CollectionShare', id: string, suggestedPlan?: Array<{ __typename?: 'PlanSuggestion', feature: string, includedInCurrentPlan: boolean, plan?: { __typename?: 'Plan', cost: number, id: string, name?: string | null, period: Types.PlanPeriod, tier: Types.PlanTier, title: string, userLimit?: number | null, version?: number | null } | null } | null> | null } | null };


export const GetShareFeatureGateSuggestions = /*#__PURE__*/ gql`
    query GetShareFeatureGateSuggestions($shareId: ID!) {
  share(shareId: $shareId) {
    id
    suggestedPlan {
      ...PlanSuggestionInfo
    }
  }
}
    ${PlanSuggestionInfo}` as unknown as DocumentNode<GetShareFeatureGateSuggestionsQuery, GetShareFeatureGateSuggestionsQueryVariables>;

          

          export const useGetShareFeatureGateSuggestionsQuery = (options?:QueryHookOptions<GetShareFeatureGateSuggestionsQuery, GetShareFeatureGateSuggestionsQueryVariables>) => useQuery(GetShareFeatureGateSuggestions, options);

          

          export type GetShareFeatureGateSuggestionsQueryOptions = QueryHookOptions<GetShareFeatureGateSuggestionsQuery, GetShareFeatureGateSuggestionsQueryVariables>;

          

          export const useGetShareFeatureGateSuggestionsLazyQuery = (options?:LazyQueryHookOptions<GetShareFeatureGateSuggestionsQuery, GetShareFeatureGateSuggestionsQueryVariables>) => useLazyQuery(GetShareFeatureGateSuggestions, options);

          

          export type GetShareFeatureGateSuggestionsQueryResult = ReturnType<typeof useGetShareFeatureGateSuggestionsQuery>;

          
